// Canonical chart-of-account name map + per-customer override helpers.
// The map is the shared standard fallback; per-customer overrides live on
// customer.accountNames (array of { account, name }). All helpers are PURE:
// they never mutate DEFAULT_ACCOUNT_MAP (CLAUDE.md shared-state rule).

export const DEFAULT_ACCOUNT_MAP = {
    '1200': 'Aktiverte kostn. gruppe d',
    '1201': 'Aktiverte kostn. gruppe a',
    '1202': 'Aktiverte kostn. leide lokaler',
    '1460': 'Lagerbeholdning salgsvarer',
    '1480': 'Forskudd til leverandører',
    '1510': 'Kunder',
    '1511': 'Avsetning for kundetap',
    '1525': 'Annen kundefordring',
    '1530': 'Annen kundefordring2',
    '1610': 'Fordring forsikring Agria',
    '1612': 'Fordring forsikring Codan',
    '1614': 'Fordring forsikring DnB NOR',
    '1616': 'Fordring forsikring Enter',
    '1618': 'Fordring forsikring Gjensidige',
    '1620': 'Fordring forsikring IF',
    '1622': 'Fordring forsikring Jernbanepersonalets',
    '1623': 'Fordring forsikring Nemi',
    '1624': 'Fordring forsikring Sparebank1',
    '1626': 'Fordring forsikring Storebrand',
    '1628': 'Fordring forsikring Tennant',
    '1630': 'Fordring forsikring Terra',
    '1632': 'Fordring forsikring Tryg Vesta',
    '1634': 'Fordring forsikring Frende',
    '1636': 'Fordring forsikring - annet selskap',
    '1910': 'Kasse',
    '1913': 'Bank kort (fordring)',
    '1915': 'Visa (fordring)',
    '1916': 'Eurocard (fordring)',
    '1917': 'Diners (fordring)',
    '1925': 'Fording på inkassoselskap kundeinnbetalinger',
    '1935': 'Bank plasseringskonto',
    '1939': 'Bank folio',
    '1940': 'Bank skattetrekk',
    '2000': 'Aksjekapital',
    '2020': 'Overkursfond',
    '2050': 'Egenkapital fri',
    '2114': 'Skyldig konsulent avg.fritt',
    '2410': 'Leverandører',
    '2412': 'Skyldig konsulent',
    '2500': 'Skyldig skatt utsatt',
    '2510': 'Skyldig skatt betalbar',
    '2610': 'Skyldig Skattetrekk',
    '2710': 'Utgående mva',
    '2720': 'Inngående mva',
    '2730': 'Investeringsavgift',
    '2750': 'Fylkesskattesjefen',
    '2780': 'Skyldig arbeidsgiveravgift',
    '2781': 'Skyldig arbeidsg.avg feriep',
    '2782': 'Gjeld bank',
    '2800': 'Skyldig utbytte',
    '2910': 'Skyldig lønn, feriepenger etc',
    '2920': 'Skyldig Feriepenger',
    '2930': 'Gjeld til ansatte og aksjonærer',
    '2960': 'Påløpne kostnader',
    '2965': 'Annen kortsiktig gjeld',
    '3000': 'Honorar',
    '3001': 'Medisinsk utstyr',
    '3003': 'Medisin',
    '3010': 'Poliklinikk',
    '3011': 'Fôrsalg',
    '3012': 'Rekvisitasalg',
    '3015': 'Varesalg avgiftsfritt',
    '3019': 'Ande salgsinntekter',
    '3030': 'Tenner',
    '3032': 'Røntgen/Ultralyd',
    '3034': 'Pelsstell',
    '3036': 'Vaksiner',
    '3038': 'Andre klinikkinntekter',
    '3040': 'Operasjon vanlig',
    '3042': 'Operasjon Spesialist',
    '3044': 'Lab eksternt',
    '3046': 'Lab internt',
    '3069': 'Fysio/kiro/rehab',
    '3120': 'Salgsinntekt tjenester, fritatt for mva',
    '3200': 'Salgsinntekt varer, unntatt mva',
    '3220': 'Salgsinntekt tjenester, unntatt mva',
    '3620': 'Leieinntekter klinikk',
    '3900': 'Andre inntekter',
    '4006': 'Varekjøp - vaksiner',
    '4008': 'Varekjøp - medisin',
    '4010': 'Varekjøp - utstyr (vet) forbr.',
    '4012': 'Varekjøp - salgsrekvisita',
    '4013': 'Varekjøp - fôr',
    '4019': 'Varekjøp - annet',
    '4090': 'Beholdningsendring varer',
    '4110': 'Varekjøp - avgiftsfritt',
    '4510': 'Andre fremmede tjenester',
    '4511': 'Konsulent',
    '4512': 'Analyser, kremering',
    '5010': 'Lønn',
    '5130': 'Lønn u.feriep.gr.lag',
    '5190': 'Feriepenger',
    '5410': 'Arbeidsgiveravgift',
    '5411': 'Arbeidsgiveravgift på feriepenger',
    '5960': 'Sosiale kostnader',
    '5990': 'Andre godtgjørelser',
    '6010': 'Ordinære avskrivinger',
    '6290': 'Leiekostnader mva-fritt',
    '6300': 'Leiekostnader mva pliktig',
    '6340': 'Strøm',
    '6540': 'Utstyr, inventer (uaktivert)',
    '6700': 'Regnskap, revisjon mv',
    '6730': 'Inkassokostnader',
    '6800': 'Kontorrekvisita, trykksaker mv',
    '6840': 'Aviser og Tidsskrifter',
    '6850': 'Faglitteratur',
    '6860': 'Kurs (inkl. reise og diett)',
    '6900': 'Telefon',
    '6940': 'Porto',
    '7100': 'Bilgodtgjørelse',
    '7140': 'Andre reise og diettkostn.',
    '7320': 'Reklame Div',
    '7322': 'Reklame Telekatalog',
    '7323': 'Reklame Internett',
    '7410': 'Kontingenter og gaver',
    '7500': 'Forsikringer',
    '7600': 'Patentkostnader',
    '7790': 'Andre driftskostnader',
    '7830': 'Tap på fordringer',
    '7832': 'Ettergitt',
    '8050': 'Renteinntekter',
    '8150': 'Renteutgifter',
    '8190': 'Andre finanskostnader',
    '8192': 'Andre ekstraordinære kostnader',
    '8600': 'Skattekostnad betalbar',
    '8620': 'Skattekostnad utsatt',
    '8800': 'Årsoppgjør',
    '8920': 'Utbytte',
    '8931': 'Privatkonto uttak kontanter',
    '8939': 'Privatkonto uttak annet',
    '8950': 'Tilførte midler',
    '3013': 'Medisinering',
    '3050': 'Varer som takst',
    '1920': 'Vipps',
    '1950': 'Ansatt rabatt',
    '1700': 'Kreditt egenandel ansatte (lønn)',
};

// customer.accountNames (array) -> { [numStr]: name }, ignoring blanks/invalids.
function overridesToMap(customer) {
    const list = (customer && customer.accountNames) || [];
    const map = {};
    for (let i = 0; i < list.length; i += 1) {
        const row = list[i] || {};
        const account = parseInt(row.account, 10);
        const name = typeof row.name === 'string' ? row.name.trim() : '';
        if (account > 0 && name) {
            map[String(account)] = name;
        }
    }
    return map;
}

// New merged object (default ∪ overrides). NEVER mutates DEFAULT_ACCOUNT_MAP.
export function buildAccountMap(customer) {
    return { ...DEFAULT_ACCOUNT_MAP, ...overridesToMap(customer) };
}

// Override name -> standard name -> ''.
export function getAccountName(account, customer) {
    if (account === null || account === undefined || account === '' || account === 0) {
        return '';
    }
    const key = String(account);
    const overrides = overridesToMap(customer);
    return overrides[key] || DEFAULT_ACCOUNT_MAP[key] || '';
}

// [[3013, '3013 - Honorar'], ...] for <select> lists. Merged + custom-added, sorted asc.
export function getAccountOptions(customer) {
    const merged = buildAccountMap(customer);
    return Object.keys(merged)
        .map(key => parseInt(key, 10))
        .filter(num => num > 0)
        .sort((a, b) => a - b)
        .map(num => [num, `${num} - ${merged[String(num)]}`]);
}

// Pure upsert. Blank name removes the override. Returns a NEW array.
export function setAccountName(list, account, name) {
    const acc = parseInt(account, 10);
    const trimmed = typeof name === 'string' ? name.trim() : '';
    const base = (list || []).filter(r => parseInt(r.account, 10) !== acc);
    if (!(acc > 0) || !trimmed) {
        return base;
    }
    return [...base, { account: acc, name: trimmed }];
}

// Pure remove. Returns a NEW array.
export function removeAccountName(list, account) {
    const acc = parseInt(account, 10);
    return (list || []).filter(r => parseInt(r.account, 10) !== acc);
}
